<template>
  <div>
    <div class="title-box1">
      <p class="title1">{{ $t("home.introduction.title.text1") }}</p>
      <p class="title2 mt20">
        {{ $t("home.introduction.title.text2") }}
      </p>
      <div class="title-img-box">
        <div class="item">
          <img
            class="home-img1"
            src="@/assets/img/images/home-img1.png"
            alt="home-img1.png"
          />
          <div class="c-flex title3">
            <div style="background: #4063ff">
              {{ $t("home.introduction.title.merchant1") }}
            </div>
            <p>
              {{ $t("home.introduction.title.text3") }}
            </p>
          </div>
          <p class="title4">
            {{ $t("home.introduction.title.text4") }}
          </p>
        </div>
        <div class="item">
          <img
            class="home-img1"
            src="@/assets/img/images/home-img2.png"
            alt="home-img2.png"
          />
          <div class="c-flex title3">
            <div style="background: #e35561">
              {{ $t("home.introduction.title.merchant2") }}
            </div>
            <p>
              {{ $t("home.introduction.title.text5") }}
            </p>
          </div>
          <p class="title4">
            {{ $t("home.introduction.title.text6") }}
          </p>
        </div>
      </div>
    </div>
    <div class="qr-code-box">
      <p class="title11">
        {{ $t("home.introduction.title.text7") }}
      </p>
      <p class="title2">
        {{ $t("home.introduction.title.text8") }}
        <!-- {{ $t("home.download.ios") }} -->
      </p>
      <div class="icon-box">
        <el-dropdown placement="top">
          <div class="item c-flex-center">
            <img
              class="icon-img"
              src="@/assets/img/images/icon/ios-icon.png"
              alt="ios-icon.png"
            />
            {{ $t("home.download.ios") }}
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <img
              class="qr-code-img"
              style="width: 138px; height: 138px; margin: 8px 12px 2px 12px"
              src="@/assets/img/images/qr-code.png"
              alt="qr-code.png"
            /> -->
			<qriously :value="'https://testflight.apple.com/join/Ps2dsBD6'" :size="130" qr-color="#4063ff" class="qr-code-img" style="width: 138px; height: 138px; margin: 8px 12px 2px 12px"/>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown placement="top">
          <div class="item c-flex-center">
            <img
              class="icon-img"
              src="@/assets/img/images/icon/android-icon.png"
              alt="android-icon.png"
            />
            {{ $t("home.download.android") }}
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <img
              class="qr-code-img"
              style="width: 138px; height: 138px; margin: 8px 12px 2px 12px"
              src="@/assets/img/images/qr-code.png"
              alt="qr-code.png"
            /> -->
			<qriously :value="'https://rwa.ltd/app/release/rwa-release-1.apk'" :size="138" qr-color="#4063ff" class="qr-code-img" style="width: 138px; height: 138px; margin: 8px 12px 2px 12px"/>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.title-box1 {
  margin-top: 120px;
  .title1 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 36px;
    color: #333333;
  }
  .title2 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #999999;
  }
  .title-img-box {
    display: flex;
    gap: 80px;
    justify-content: center;
    margin-top: 60px;
    .item {
      max-width: 500px;
      text-align: center;
    }
    .home-img1 {
      width: 286px;
      height: 200px;
    }
    .title3 {
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        width: 40px;
        height: 28px;
        margin-right: 8px;
        text-align: center;
        line-height: 28px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        border-radius: 6px 6px 6px 6px;
      }
      margin-top: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }
    .title4 {
      text-align: center;
      margin-top: 15px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
    }
  }
}
.qr-code-box {
  padding: 120px 0;
  margin-top: 120px;
  text-align: center;
  background: #4063ff;
  .title11 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 36px;
    color: #ffffff;
  }
  .title2 {
    margin: 0 auto;
    text-align: center;
    max-width: 1000px;
    margin-top: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
  }
  .icon-box {
    display: flex;
    gap: 80px;
    justify-content: center;
    margin-top: 40px;
    .qr-code-img {
      width: 138px;
      height: 138px;
      margin: 12px;
    }
    .item {
      cursor: pointer;
      .icon-img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      width: 220px;
      height: 48px;
      line-height: 48px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
    }
  }
}
</style>
